const CEFR_LEVEL_PATTERN = /^(A1|A2|B1|B2|C1|C2)$/;
const CEFR_LEVEL_EXTRACT_PATTERN = /(A1|A2|B1|B2|C1|C2)/gi;
const CEFR_LEVEL_ORDER = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];
const CEFR_LEVEL_RANK = CEFR_LEVEL_ORDER.reduce((acc, level, index) => {
  acc[level] = index;
  return acc;
}, {});

export function normalizeCefrLevel(value) {
  if (typeof value !== 'string') return null;
  const normalized = value.trim().toUpperCase();
  return CEFR_LEVEL_PATTERN.test(normalized) ? normalized : null;
}

export function extractCefrLevels(value) {
  if (typeof value !== 'string') return [];
  const normalized = value.trim().toUpperCase();
  if (!normalized) return [];
  if (CEFR_LEVEL_PATTERN.test(normalized)) return [normalized];
  const matches = normalized.match(CEFR_LEVEL_EXTRACT_PATTERN) || [];
  return Array.from(new Set(matches.map((match) => match.toUpperCase())));
}

export function normalizeReaderLevelCodes(value, fallbackValue = null) {
  const rawValues = Array.isArray(value) ? value.flat(Infinity) : [value];
  const levelCodes = rawValues
    .flatMap((entry) => extractCefrLevels(entry))
    .filter((code, index, list) => list.indexOf(code) === index)
    .sort((left, right) => (CEFR_LEVEL_RANK[left] ?? 99) - (CEFR_LEVEL_RANK[right] ?? 99));

  if (levelCodes.length > 0) return levelCodes;

  const fallbackLevels = extractCefrLevels(fallbackValue);
  if (fallbackLevels.length > 0) return fallbackLevels;

  return ['A2'];
}

export function formatReaderLevelLabel(levelCodes, fallbackValue = null) {
  const normalizedCodes = normalizeReaderLevelCodes(levelCodes, fallbackValue);
  if (normalizedCodes.length === 1) return normalizedCodes[0];
  return normalizedCodes.join(', ');
}

export function readerSupportsLevel(levelValue, requestedLevel, fallbackValue = null) {
  const normalizedRequestedLevel = normalizeCefrLevel(requestedLevel);
  if (!normalizedRequestedLevel) return true;
  return normalizeReaderLevelCodes(levelValue, fallbackValue).includes(normalizedRequestedLevel);
}

export function getPrimaryReaderLevel(levelValue, fallbackValue = null) {
  return normalizeReaderLevelCodes(levelValue, fallbackValue)[0] || 'A2';
}

export function getReaderLevelRank(levelValue, fallbackValue = null) {
  const primaryLevel = getPrimaryReaderLevel(levelValue, fallbackValue);
  return CEFR_LEVEL_RANK[primaryLevel] ?? Number.MAX_SAFE_INTEGER;
}
